import React from 'react';
import Search from './Search';
import JiraStatusFilter from './JiraStatusFilter';
import PhysycianFilter from './PhysycianFilter';
import Status from './StatusFilter';
import NotificationFilter from './NotificationFilter';
import MuiThemeDataTable from './MuiThemeDataTable';
import { withStyles } from '@material-ui/core';
import GridItem from './Grid/GridItem';
import GridContainer from './Grid/GridContainer';

const styles = theme => ({
    pad: {
        paddingLeft: "4px",
        paddingBottom:"10px",
        [theme.breakpoints.down("sm")]: {
            paddingLeft: 15, marginBottom: 5
        }
    },
    pad5: {
        marginBottom: 0,
        [theme.breakpoints.down("sm")]: {
            marginBottom: 5
        }
    },
});

class SearchAndTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            patientList: null,
            filterPatientList: null,
            physicianFilterPatients: '',
            statusFiterdata:null,
            notificationFilterPatientList: null,
            row:[],
        };
    }
    componentDidMount(){
        this.setState({row:this.props.patientList});
    }
    changePatientList = (selecteddPatientList) => {
        if (selecteddPatientList !== undefined) {
            if (selecteddPatientList.length > 0) {
                this.setState({ patientList: selecteddPatientList, row: selecteddPatientList });
            } else if (selecteddPatientList.length === 0) {
                this.setState({ patientList: [],row:[] });
            } else {
                this.setState({ patientList: null,row:null });
            }
        }
    };
    filterBasedAssigneeName = (selectedValue) => {
        let filteredListPhysicianList = this.state.filterPatientList !== null ? this.state.filterPatientList : this.state.statusFiterdata;
        if (selectedValue !== undefined) {
            if (selectedValue.length > 0) {
                filteredListPhysicianList = filteredListPhysicianList.filter((obj) => {
                    let checkPhysicianForFilter = selectedValue.map((item) => {
                        if (item.label === obj.Assignee.jiraAssignee[obj.Assignee.jiraAssignee.length-1]) {
                            return true;
                        } else {
                            return false;
                        }
                    });
                    let returnTrueOrFalse = false;
                    for (let i = 0; i < checkPhysicianForFilter.length; i++) {
                        if (checkPhysicianForFilter[i] === true) {
                            returnTrueOrFalse = true;
                            break;
                        }
                    }
                    return returnTrueOrFalse;
                });
            }
        }
            if (selectedValue !== undefined) {
            if (selectedValue.length > 0) {
                this.setState({ notificationFilterPatientList: filteredListPhysicianList,row:filteredListPhysicianList  });
            }
            if (selectedValue.length === 0) {
                this.setState({ notificationFilterPatientList: this.state.filterPatientList,row: this.state.filterPatientList  });
            }
        } else {
            this.setState({ notificationFilterPatientList: null ,row: null});
        }
    };
    filterPatientBasedStatus = (selectedJiraStatus) => {
        let filteredList = this.state.statusFiterdata!== null?this.state.statusFiterdata:this.state.physicianFilterPatients;
        if (selectedJiraStatus !== undefined) {
            if (selectedJiraStatus.length > 0) {
                filteredList = this.state.statusFiterdata.filter((obj) => {
                    let checkStatusForFilter = selectedJiraStatus.map((item) => {
                        if (item.label === obj.JiraTicket.jirastatus[obj.JiraTicket.jirastatus.length-1]) {
                            return true;
                        } else {
                            return false;
                        }
                    });
                    let returnTrueOrFalse = false;
                    for (let i = 0; i < checkStatusForFilter.length; i++) {
                        if (checkStatusForFilter[i] === true) {
                            returnTrueOrFalse = true;
                            break;
                        }
                    }
                    return returnTrueOrFalse;
                });
            }
        }
        if (selectedJiraStatus !== undefined) {
            if (selectedJiraStatus.length > 0) {
                this.setState({ filterPatientList: filteredList, row: filteredList });
            }
            if (selectedJiraStatus.length === 0) {
                this.setState({ filterPatientList: this.state.statusFiterdata,row: this.state.statusFiterdata });
            }
        } else {
            this.setState({ filterPatientList: null,row: null  });
        }
    };
    filterPhysicianPatient = (selectedValue) => {
        let filteredListPhysicianList = this.props.patientList;
        if (selectedValue !== undefined) {
            if (selectedValue.length > 0) {
                filteredListPhysicianList = this.props.patientList.filter((obj) => {
                    let checkPhysicianForFilter = selectedValue.map((item) => {
                        if (item.label === obj.createdBy||item.label === obj.modifiedBy) {
                            return true;
                        }
                        if (item.label == "Unavailable") {
                            if ("" === obj.createdBy || "" === obj.modifiedBy) {
                                return true;
                            } else {
                                return false;
                            }
                        } else {
                            return false;
                        }
                    });
                    let returnTrueOrFalse = false;
                    for (let i = 0; i < checkPhysicianForFilter.length; i++) {
                        if (checkPhysicianForFilter[i] === true) {
                            returnTrueOrFalse = true;
                            break;
                        }
                    }
                    return returnTrueOrFalse;
                });
            }
        }
        if (selectedValue !== undefined) {
            if (selectedValue.length > 0) {
                this.setState({ physicianFilterPatients: filteredListPhysicianList,row: filteredListPhysicianList });
            }
            if (selectedValue.length === 0) {
                this.setState({ physicianFilterPatients: this.props.patientList,row: this.props.patientList });
            }
        } else {
            this.setState({ physicianFilterPatients: this.props.patientList,row: this.props.patientList });
        }
    };
    filterbasedstatus = (selectedStatus) => {
    let filteredList = this.state.physicianFilterPatients;
        if (selectedStatus !== undefined) {
            if (selectedStatus.length > 0) {
                filteredList = this.state.physicianFilterPatients.filter((obj) => {
                    let checkStatusForFilter = selectedStatus.map((item) => {
                        if (item.value === obj.Deleted.Deleted[obj.Deleted.Deleted.length-1]) {
                            return true;
                        } else {
                            return false;
                        }
                    });
                    let returnTrueOrFalse = false;
                    for (let i = 0; i < checkStatusForFilter.length; i++) {
                        if (checkStatusForFilter[i] === true) {
                            returnTrueOrFalse = true;
                            break;
                        }
                    }
                    return returnTrueOrFalse;
                });
            }
        }
        if (selectedStatus !== undefined) {
            if (selectedStatus.length > 0) {
                this.setState({ statusFiterdata:filteredList, row: filteredList });
            }
            if (selectedStatus.length === 0) {
                this.setState({ statusFiterdata:this.state.physicianFilterPatients,row:this.state.physicianFilterPatients });
            }
        } else {
            this.setState({ statusFiterdata: null,row: null  });
        }
};
    render() {

        const { classes } = this.props;
        const hideDownloadIcon = false;
        const hideSearchIcon = false;
        const hideFilterIcon = false;
        const viewColumnsIcon = false;
        return (
        <>
            <div style={{ padding: "10px", backgroundColor: "#eceded" }}>
                <GridContainer>
                    <GridItem md={12} className={classes.pad}>
                    <Search list={this.props.patientList} filterPatientList={this.changePatientList} reqAttentionFilter={this.props.reqAttentionFilter} />
                    </GridItem>
                    <GridItem md={3} className={classes.pad5}>
                    <PhysycianFilter filterPhysicianPatient={this.filterPhysicianPatient} physicianList={this.props.patientList}/>
                    </GridItem>
                    <GridItem md={3} className={classes.pad5}>
                    <Status filterbasedstatus={this.filterbasedstatus} ContentList={this.state.physicianFilterPatients}/>
                    </GridItem>
                    <GridItem md={3}className={classes.pad5}>
                    <JiraStatusFilter filterPatientStatus={this.filterPatientBasedStatus} patientList={this.state.statusFiterdata}/>
                    </GridItem>
                    <GridItem md={3}className={classes.pad5}>
                    <NotificationFilter filterAssignee={this.filterBasedAssigneeName} patientList={this.state.filterPatientList}/>
                    </GridItem>
                </GridContainer>
            </div>
        {this.props.patientList.length > 0 ?
                <MuiThemeDataTable rows={this.state.row} columns={this.props.columns} customSort={this.props.customSort} tableContent={this.props.tableContent}
                hideDownloadIcon={hideDownloadIcon} hideSearchIcon={hideSearchIcon} hideFilterIcon={hideFilterIcon} viewColumnsIcon={viewColumnsIcon} patientsEmpty={true}
                userRole={this.props.userRole} handleAddNewPatient={this.props.handleAddNewPatient} />
            : <><MuiThemeDataTable userRole={this.props.userRole} rows={this.state.patientList !== null ? this.state.patientList : this.state.notificationFilterPatientList !== null ?
            this.state.notificationFilterPatientList : this.state.filterPatientList !== null ? this.state.filterPatientList : this.state.physicianFilterPatients} columns={this.props.columns}
            customSort={this.props.customSort} tableContent={this.props.tableContent} hideDownloadIcon={hideDownloadIcon} hideSearchIcon={hideSearchIcon} hideFilterIcon={hideFilterIcon}
            viewColumnsIcon={viewColumnsIcon} patientsEmpty={true} handleAddNewPatient={this.props.handleAddNewPatient} /></>}
            </>
        );
    }
}
export default (withStyles(styles)(SearchAndTable));